import { entryCountMap, validityPeriodMap } from '../consts/product-const';

export default {
  // 获取入境次数中文
  getEntryCountCN(num, unit) {
    if (unit === 0) {
      // 次数
      return `${num === 1 ? '单' : num}${entryCountMap[unit]}`;
    }
    return entryCountMap[unit] || '';
  },

  // 获取入境次数中文
  getValidityPeriodCN(num, unit) {
    if ([0, 1, 2].indexOf(unit) > -1) {
      // 次数
      return `${num}${unit === 1 ? '个' : ''}${validityPeriodMap[unit]}`;
    }
    return validityPeriodMap[unit] || '';
  },
};
